import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {
    Box, Accordion, AccordionSummary, AccordionDetails, Typography, Alert
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getApplicationType } from '../../../../../../actions/rof-burns/rof-actions';

export default function RofApplicationMedia({ projectKey }) {
    const dispatch = useDispatch();
    const [hideState, setHideState] = useState({});
    const applicationTypes = useSelector((state) => (state.rofBurnsReducer.applicationTypes))

    const toggleHide = (applicationId) => {
        setHideState(prevState => ({
            ...prevState,
            [applicationId]: !prevState[applicationId]
        }));
    };

    useEffect(() => {
        dispatch(getApplicationType(projectKey));
    }, [dispatch, projectKey]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h5'>Biochar Application Media</Typography>
            <Box>
                {!applicationTypes || applicationTypes?.data?.length === 0
                    ? <Alert severity="info" sx={{ width: 'fit-content' }}>
                        No Biochar Application Data available for this project
                    </Alert>
                    : applicationTypes?.data?.map((application, index) => (
                        <Accordion key={index}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                                onClick={() => toggleHide(`Application-${index}`)}
                            >
                                <Typography>
                                    {hideState[`Application-${index}`] ? "Hide" : "Expand"} {application.batchId}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box sx={{ display: 'flex', flexDirection: 'column', mb: 5 }}>
                                    <img src={application.biocharToSoilPhoto} alt={'biochar to soil photo'} width="300" />
                                    <Typography sx={{ mt: 2 }}>
                                        <b>Kiln Used:</b> {application.kilnUsed || "N/A"}
                                    </Typography>
                                    <Typography >
                                        <b>Created At:</b> {new Date(application.createdAt).toLocaleString() || "N/A"}
                                    </Typography>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                    )}
            </Box>
        </Box>
    );
}